import { documentsTableFieldsFragment } from "@lyfegen-platform/graphql-schema/fragments";
import gql from "graphql-tag";

export const GET_DOCUMENTS_FILTERS = gql`
	query GetDocumentsFilters {
		GetDocumentsTableSourceFilterData {
			counterparties
			brandNames
			statuses
			amountRanges {
				start
				end
				count
			}
			reviewersOrganizations
			approversOrganizations
			minCoverageDate
			maxCoverageDate
			minLastRemindedOn
			maxLastRemindedOn
			minSentToReviewOn
			maxSentToReviewOn
			minReviewRemindedOn
			maxReviewRemindedOn
			minIssuedOn
			maxIssuedOn
			tags
			minCreatedOn
			maxCreatedOn
			types
			ids
			smartMipReimbursementIds
			beneficiaries
			paymentReferenceLyfegens
			minPaymentReceiptPayer
			maxPaymentReceiptPayer
			approvers
		}
		filters: GetUserContextFiltersDocuments
	}
`;
export const UPDATE_DOCUMENTS_FILTER = gql`
	mutation UpdateUserContextFiltersDocuments($req: String) {
		UpdateUserContextFiltersDocuments(req: $req)
	}
`;

export const GET_ALL_DOCUMENT_IDS = gql`
	query GetAllDocumentIds($where: DocumentTableRowWhere, $options: DocumentTableRowOptions) {
		documentTableRows(where: $where, options: $options) {
			id
			finalInvoiceAmount
			currency
		}
	}
`;

export const GET_DOCUMENTS = gql`
	${documentsTableFieldsFragment}

	query GetDocuments($where: DocumentTableRowWhere, $options: DocumentTableRowOptions) {
		documentTableRows(where: $where, options: $options) {
			...GetDocumentsFields
			finalInvoiceAmount
			hasAdjustedTransactions
		}

		filteredDocumentCount: documentTableRows(where: $where) {
			_count
		}

		allDocumentCount: documentTableRows {
			_count
		}
	}
`;

export const GET_FILTERED_DOCUMENT_COUNT = gql`
	query GetFilteredDocumentCount($where: DocumentTableRowWhere) {
		filteredDocumentCount: documentTableRows(where: $where) {
			_count
		}
	}
`;

export const DOCUMENTS_SUBSCRIPTION = gql`
	subscription OnDocumentCreated {
		documentCreated
	}
`;

export const DOCUMENT_UPDATE_SUBSCRIPTION = gql`
	subscription OnDocumentUpdated {
		documentUpdated {
			documentId
			tenantId
			updatedById
		}
	}
`;
